<script setup lang="ts">
defineProps<{
  allergen: any
}>()
const { t } = useLocale()
</script>

<template>
  <section class="flex items-center gap-5 p-4">
    <img
      class="h-5 w-5"
      :src="`/images/icons/allergens/${allergen}.svg`"
      :alt="t(`productDetailStatic.allergens.items.${allergen}`)"
    />
    <p>{{ t(`productDetailStatic.allergens.items.${allergen}`) }}</p>
  </section>
</template>
